import React from 'react'
import NavbarCommon from '../components/NavbarCommon'
import EditSearch from '../components/EditSearch'
import FilterSearch from '../components/FilterSearch'
// import { DataContext } from '../context/DataProvider'

function Lowongan_kerja() {
  // const { fetchData } = useContext(DataContext);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // console.log(fetchData)

  return (
    <>
    <NavbarCommon />
    <EditSearch />
    <FilterSearch />
    </>
  )
}

export default Lowongan_kerja